import { useQuery } from "@tanstack/react-query";
import { api } from "./client";

export interface FundOption {
  id: string;
  name: string;
  donorId: string | null;
  restricted: boolean;
}

export interface CategoryOption {
  id: string;
  name: string;
  type: string;
}

export interface BankAccountOption {
  id: string;
  name: string;
  kind: string;
}

export function useFundsQuery(enabled = true) {
  return useQuery({
    queryKey: ["reference", "funds"],
    queryFn: () => api.get<{ funds: FundOption[] }>("/funds"),
    enabled,
    staleTime: 60_000,
  });
}

export function useCategoriesQuery(type: "income" | "expense", enabled = true) {
  return useQuery({
    queryKey: ["reference", "categories", type],
    queryFn: () =>
      api.get<{ categories: CategoryOption[] }>(`/reference/categories?type=${type}`),
    enabled,
    staleTime: 60_000,
  });
}

export function useBankAccountsQuery(enabled = true) {
  return useQuery({
    queryKey: ["reference", "bank-accounts"],
    queryFn: () =>
      api.get<{ bankAccounts: BankAccountOption[] }>("/reference/bank-accounts"),
    enabled,
    staleTime: 60_000,
  });
}

export interface FiscalPeriodOptions {
  fiscalYearId: string;
  fiscalYearName: string;
  startsOn: string;
  endsOn: string;
  months: string[];
  defaultPeriod: string;
}

export function useFiscalPeriodsQuery(enabled = true) {
  return useQuery({
    queryKey: ["reference", "fiscal-periods"],
    queryFn: async () => {
      const response = await api.get<{ fiscalPeriods: FiscalPeriodOptions | null }>(
        "/reference/fiscal-periods",
      );
      return response.fiscalPeriods;
    },
    enabled,
    staleTime: 60_000,
  });
}
